import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty(_context3 = ownKeys(source, true)).call(_context3, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty(_context4 = ownKeys(source)).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Children } from 'react';
import { compose, branch, mapProps, setDisplayName } from 'recompose';
import types from 'prop-types';
import { styled, StyleSheet } from '@rexlabs/styling';
var assign = _Object$assign;
var errorStyles = StyleSheet({
  container: {
    backgroundColor: 'red',
    color: 'white',
    fontSize: '0.9rem',
    borderRadius: 3,
    margin: '2px 0',
    padding: '0.25em 0.5em'
  }
});
var ErrorMessage = styled(errorStyles)(assign(function (_ref) {
  var text = _ref.text,
      styles = _ref.styles;
  return React.createElement("div", styles('container'), text);
}, {
  displayName: 'ErrorMessage'
}));

var mapErrors = function mapErrors(errors) {
  var _context;

  return _mapInstanceProperty(_context = _filterInstanceProperty(errors).call(errors, Boolean)).call(_context, function (message) {
    return React.createElement(ErrorMessage, {
      text: message,
      key: message
    });
  });
};

var withInlineErrors = compose(setDisplayName('behaviour(InlineErrors)'), mapProps(function (_ref2) {
  var _context2;

  var errors = _ref2.errors,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["errors", "children"]);

  return _objectSpread({}, props, {
    children: _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(Children.toArray(children)), _toConsumableArray(mapErrors(errors)))
  });
}));
var withoutInlineErrors = compose(setDisplayName('behaviour(NoInlineErrors)'), mapProps(function (_ref3) {
  var errors = _ref3.errors,
      props = _objectWithoutProperties(_ref3, ["errors"]);

  return props;
}));
export default compose(setDisplayName('behaviour(with-inline-errors)'), branch(function (_ref4) {
  var errors = _ref4.errors;
  return errors && errors.length;
}, withInlineErrors, withoutInlineErrors));
export var propTypes = {
  errors: types.arrayOf(types.string)
};